import { render, staticRenderFns } from "./Flags.vue?vue&type=template&id=ccb97c2a&"
import script from "./Flags.vue?vue&type=script&lang=js&"
export * from "./Flags.vue?vue&type=script&lang=js&"
import style0 from "./Flags.vue?vue&type=style&index=0&id=ccb97c2a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports